import { Paper } from '@mui/material';
import { listBoxPaperStyleBuilder } from './listBoxStyleBuilder';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { Box } from '../../Box';
import { idBuilder } from '../../internal';
import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export const ListBoxMessage = props => {
  const {
    maxWidth,
    minWidth,
    children,
    id,
    style,
    onClick,
    onKeyDown,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  const paperStyle = listBoxPaperStyleBuilder(theme, 'auto', maxWidth, minWidth);
  return /*#__PURE__*/_jsx(Paper, {
    sx: paperStyle,
    className: 'interstate-listbox-root',
    children: /*#__PURE__*/_jsx(Box, {
      display: 'flex',
      gap: '4px',
      padding: '8px 16px',
      sx: style,
      id: idBuilder('ids-listbox-message-root', id),
      "data-testid": idBuilder('ids-listbox-message-root', rest['data-testid']),
      className: clsx(['ids-list-box-item', 'ids-list-box-message-root']),
      onClick: onClick,
      onKeyDown: onKeyDown,
      children: children
    })
  });
};